import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { t } from 'i18next';

interface HelpIconProps {
  onClick: () => void;
}

const HelpIcon: React.FC<HelpIconProps> = ({ onClick }) => {
  return (
    <Tooltip title={t('bsc.label.huongdansudung', 'Hướng dẫn sử dụng')}>
      <div 
        onClick={onClick}
        className="cursor-pointer text-gray-600 hover:text-blue-500 transition-colors duration-200"
        style={{ fontSize: '20px', marginTop: '4px', marginRight: '12px' }}
      >
        <QuestionCircleOutlined />
      </div>
    </Tooltip>
  );
};

export default HelpIcon;

